import { Steps } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './Stepper.module.scss';
import { useStepper } from 'LearningManager/hooks/Stepper.context';
import classNames from 'classnames';

const { Step } = Steps;

const Stepper: React.FC = () => {
	const { t } = useTranslation();
	const { current, steps, setupType, isSetupSelection } = useStepper();

	// The selection screen is before step 1, so no step is current there — a
	// current of -1 leaves every step in antd's "wait" state.
	const currentStep = isSetupSelection ? -1 : current;

	return (
		<div id="lms-ca-stepper" className={styles.root}>
			<div
				id="lms-ca-stepper-inner"
				className={classNames(styles.stepper, {
					[styles['stepper--custom']]: setupType === 'Custom Setup'
				})}
			>
				<Steps
					initial={0}
					current={currentStep}
					labelPlacement="vertical"
				>
					{steps.map((item, index) => (
						<Step
							key={item.title}
							title={
								<span
									id={`lms-ca-stepper-step-${index}`}
									data-step-index={index}
								>
									{t(item.title)}
								</span>
							}
						/>
					))}
				</Steps>
			</div>
		</div>
	);
};

export default Stepper;
